import {Component} from '@angular/core';

@Component({
  selector: 'app-ts-v2-stats-band-section',
  templateUrl: './stats-band-section.component.html',
  styleUrls: ['./stats-band-section.component.scss'],
})
export class V2StatsBandSectionComponent {
  stats = [
    {statKey: 'talentSearchV2.stats.stat1', labelKey: 'talentSearchV2.stats.label1', subKey: 'talentSearchV2.stats.sub1'},
    {statKey: 'talentSearchV2.stats.stat2', labelKey: 'talentSearchV2.stats.label2', subKey: 'talentSearchV2.stats.sub2'},
    {statKey: 'talentSearchV2.stats.stat3', labelKey: 'talentSearchV2.stats.label3', subKey: 'talentSearchV2.stats.sub3'},
  ];
}
